function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import Icon from "../../../Icon";
import React, { useEffect, useState } from 'react';
import "./index.less";
export var FooterItem = function FooterItem(item) {
  var renderText = function renderText(item) {
    if (item !== null && item !== void 0 && item.type) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, item.href ? /*#__PURE__*/React.createElement("a", {
        href: item.href,
        target: item.target
      }, /*#__PURE__*/React.createElement("img", {
        className: "iron-footer-type",
        src: String(item === null || item === void 0 ? void 0 : item.icon),
        alt: item === null || item === void 0 ? void 0 : item.type
      })) : /*#__PURE__*/React.createElement("img", {
        className: "iron-footer-type",
        src: String(item === null || item === void 0 ? void 0 : item.icon),
        alt: item === null || item === void 0 ? void 0 : item.type
      }));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "iron-footer-text "
    }, (item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/React.createElement(Icon, {
      name: String(item.icon),
      className: "iron-footer-text-icon"
    }), item.href ? /*#__PURE__*/React.createElement("a", {
      href: item.href,
      target: item.target,
      className: "iron-underline iron-underline-dashed"
    }, /*#__PURE__*/React.createElement("span", {
      className: "iron-footer-text-label"
    }, item.label)) : /*#__PURE__*/React.createElement("span", {
      className: "iron-footer-text-label"
    }, item.label));
  };
  var renderRow = function renderRow(item) {
    return /*#__PURE__*/React.createElement("div", {
      className: "iron-footer-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "iron-footer-row-header"
    }, renderText(item)), /*#__PURE__*/React.createElement("div", {
      className: "iron-footer-sub"
    }, item.children && item.children.map(function (subItem, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "iron-footer-sub-wrapper",
        key: index
      }, renderText(subItem));
    })));
  };
  return /*#__PURE__*/React.createElement("li", {
    className: "iron-footer-item-li",
    key: item.value
  }, item.children ? renderRow(item) : renderText(item));
};
var FooterMenu = function FooterMenu(props) {
  var item = props.item,
    visible = props.visible,
    getActiveKey = props.getActiveKey;
  var _useState = useState(visible),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setVisible = _useState2[1];
  var toggleVisibility = function toggleVisibility(e) {
    e.stopPropagation();
    setVisible(!isVisible);
    if (getActiveKey) {
      getActiveKey(item === null || item === void 0 ? void 0 : item.value);
    }
  };
  useEffect(function () {
    setVisible(visible);
  }, [visible]);
  return /*#__PURE__*/React.createElement("div", {
    className: "iron-footer-menu"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "iron-footer-header",
    onClick: toggleVisibility
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, item === null || item === void 0 ? void 0 : item.label), /*#__PURE__*/React.createElement("div", {
    className: "arrow",
    "data-expanded": isVisible
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-em-d"
  }))), /*#__PURE__*/React.createElement("ul", {
    className: "iron-footer-content mobile-accordion",
    "data-expanded": isVisible
  }, (item === null || item === void 0 ? void 0 : item.children) && (item === null || item === void 0 ? void 0 : item.children.map(function (subItem, index) {
    return /*#__PURE__*/React.createElement(FooterItem, _extends({
      key: index
    }, subItem));
  }))));
};
export default FooterMenu;